import envVar from '../../config/envVars';
import { UpsertBusRequest } from '../../modules/BusManagement/types/busTypes';
import { Bus } from '../../modules/RoutesManagement/types';
import httpGet from '../httpClient/httpGet';
import httpPost from '../httpClient/httpPost';

export const getBuses = async (school: string) => {
  return httpGet(
    `${envVar.REACT_APP_BUS_TRACKING_API_BASE_URL}/buses/school/${school}`,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_BUS_TRACKING_API_TOKEN}`
      }
    }
  );
};

export const upsertBus = async (
  payload: UpsertBusRequest
): Promise<Partial<Bus>> => {
  const response = await httpPost(
    `${envVar.REACT_APP_BUS_TRACKING_API_BASE_URL}/buses/upsert`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_BUS_TRACKING_API_TOKEN}`
      }
    }
  );
  return response.data;
};
